export default "/images/vendor/flag-icons/flags/1x1/sn.svg?07ec7ccbea282d9458ad56ee5df564bf";